import React from 'react';
import CustomScrollDiv from './custom_scroll_div';
import {Scrollbar} from '@forecast-it/design-system';

type NativeScrollProps = {
	maxHeight?: number;
	isPageScroller?: boolean;
	hasFocusableContent?: boolean;
	hideAxis?: typeof Scrollbar.Axis.Horizontal | typeof Scrollbar.Axis.Vertical; // Hacky way of getting typescript to behave
	onNativeScroll?: React.UIEventHandler<HTMLDivElement>;
};

type CustomScrollProps = {
	[key: string]: unknown;
};

// Converter component for transitioning from CustomScrollDiv to Native Scrollbar from DS
interface CustomToNativeScrollProps extends NativeScrollProps, CustomScrollProps {
	forceCustomScrollbar?: boolean; // For debugging
	children: React.ReactNode;
}
const CustomScrollToNativeScroll = ({
	forceCustomScrollbar,
	maxHeight,
	isPageScroller,
	hasFocusableContent,
	hideAxis,
	onNativeScroll,
	children,
	...props
}: CustomToNativeScrollProps): JSX.Element => {
	if (!forceCustomScrollbar) {
		return (
			<Scrollbar
				maxHeight={maxHeight}
				onScroll={onNativeScroll}
				isPageScroller={isPageScroller}
				hasFocusableContent={hasFocusableContent}
				hideAxis={hideAxis}
			>
				{children}
			</Scrollbar>
		);
	}
	return <CustomScrollDiv {...props}>{children}</CustomScrollDiv>;
};

export default CustomScrollToNativeScroll;
